<template>
    <ContentOrLoading>
        <div class="p-3" v-if="zonas.length > 0">
            <div class="d-block d-md-flex justify-content-between align-items-center mb-3">
                <h3>Configurar precios por {{ teatro.hash === 'J1fKG9AarPuPNJ5hwY0t' ? "Terrenos" : "Parcelas" }}</h3>
                <Button @click="volver" v-if="zona">Cambiar zona</Button>
            </div>
            <SvgComponent
                id="selector-zonas"
                v-if="!zona"
                :zonas="zonas" 
                :place_id="lista.recinto_parcela_id"
                :key="reloadComponent"
                @clickZona="(zonaSeleccionada) => { zona = zonaSeleccionada; getPlazas() }"
            />
            <div v-else>
                <PorPlanoAbonos
                    id="precios-parcelas"
                    v-if="preciosParcelas && svg"
                    :svg="svg"
                    :butacasFiltered="plazas"
                    :tipos="preciosParcelas"
                    :esMovil="esMovil"
                    :loading="loading"
                    @getButacas="getPlazas"
                    @guardarPrecios="guardarPrecios"
                />
            </div>
        </div>
    </ContentOrLoading>
</template>

<script>
    import SvgComponent from '@/components/svg/SvgComponent';
    import PorPlanoAbonos from '../abonos/precios/PorPlanoAbonos';

    export default {
        data() {
            return {
                svg: null,
                zonas: [],
                zona: null,
                plazas: [],
                loading: false,
                reloadComponent: 1,
                preciosParcelas: null
            }
        },
        methods: {
            getZonas() {
                this.loading = true;

                const params = {
                    filters: {},
                    lista_id: this.lista.id,
                    place_id: this.lista.recinto_parcela_id
                }

                this.$store.dispatch(this.config.getVuexAlias('front.abonos.zonas.recintos-anexos.index'), params).then(res => {
                    this.zonas = res.data.data;
                    this.zonas.forEach(zona => {
                        zona.esta_disponible = true;
                    })
                }).finally(() => {
                    this.loading = false;
                });
            },
            getPlazas() {
                this.loading = true;

                const params = {
                    filters: {},
                    lista_id: this.lista.id,
                    recinto_id: this.lista.recinto_parcela_id,
                    zona_id: this.zona.id
                }

                this.$store.dispatch(this.config.getVuexAlias('back.precios.parcela.plazas'), params).then(res => {
                    this.plazas = res.data.data?.plazas.filter(plaza => plaza.svg_id);
                    this.getPreciosParcelas();
                }).finally(() => {
                    this.loading = false;
                });
            },
            getPreciosParcelas() {
                this.loading = true;

                const params = {
                    filters: {},
                    lista_id: this.lista.id
                }

                this.$store.dispatch(this.config.getVuexAlias('back.precios.parcelas'), params).then(res => {
                    this.preciosParcelas = res.data;
                    this.getSvg();
                }).finally(() => {
                    this.loading = false;
                });
            },
            getSvg() {
                const params = {
                    filters: {},
                    recinto_id: this.lista.recinto_parcela_id,
                    region_id: this.zona.id
                }

                this.$store.dispatch(this.config.getVuexAlias('recinto.zona-svg'), params).then(res => {
                    this.svg = res.data.svg;
                }).catch(() => {
                    console.warn('Error al recuperar el svg en la configuración de precios de abonos');
                }).finally(() => {
                    this.loading = false;
                });
            },
            guardarPrecios(params) {
                this.loading = true;
            
                let newParams = params;
                newParams.plazas = params.butacas.map(butaca => {
                    const newParams = {
                        ...butaca,
                        precio_online: butaca.precios_online,
                        precio_taquilla: butaca.precios_taquilla
                    };

                    return newParams;
                });

                delete newParams.butacas;

                this.$store.dispatch(this.config.getVuexAlias('back.precios.parcelas.sync'), newParams).then(res => {
                    this.$toast.success(res.data.message);
                    this.reloadComponent++;
                    this.svg = null;
                    this.zona = null;
                }).catch(error => {
                    this.$toast.error('Error al guardar los precios de las parcelas');
                }).finally(() => {
                    this.loading = false;
                });
            },
            volver() {
                this.zona = null;
                this.svg = null;
                this.plazas = [];
                this.getZonas();
                setTimeout(() => {
                    this.$scrollTo('body', 500, { offset: document.body.scrollHeight });
                }, 1000);
            }
        },
        computed: {
            lista() {
                return this.$store.getters.getListaAbonados;
            },
            esMovil() {
                return window.innerWidth <= 768;
            },
            teatro() {
                return this.$store.getters.getTeatro;
            }
        },
        created() {
            this.getZonas();
        },
        components: {
            SvgComponent, PorPlanoAbonos
        }
    }
</script>